import type { AccountSave, Settings } from '../../game/account';

/**
 * Feature-owned save data kept on the account next to the typed fields.
 * `migrate()` spreads unknown keys through and export/import round-trip the
 * JSON, so this persists without widening `AccountSave`.
 */
export interface FeatureSave {
  /** Day-cycle anchors for the real-time reset mode. */
  clock?: { mode: 'session' | 'real'; realDay: number; realWeek: number };
}

export function featureSave(a: AccountSave): FeatureSave {
  const x = a as AccountSave & { features?: FeatureSave };
  x.features ??= {};
  return x.features;
}

/** Settings that only these features read (kept inside `account.settings`). */
export interface ExtraSettings {
  /** "Relaxed" day cycle: Rest may advance the day before the daily core is done. */
  restAnytime?: boolean;
}

export function extraSettings(a: AccountSave): Settings & ExtraSettings {
  return a.settings;
}
